import React from 'react';
import type { StudentNoteItem } from '../../../types/orchestrator';
import StudentNotesHistorySection from '../StudentNotesHistorySection/StudentNotesHistorySection';
import styles from './StudentNotesHistoryPanel.module.css';

interface StudentNotesHistoryPanelProps {
  notes: StudentNoteItem[];
  footer?: React.ReactNode;
  title?: string;
  emptyMessage?: string;
  onDeleteNote?: (noteId: number) => Promise<void>;
}

const StudentNotesHistoryPanel: React.FC<StudentNotesHistoryPanelProps> = ({
  notes,
  footer,
  title,
  emptyMessage,
  onDeleteNote,
}) => (
  <div className={styles.historySection}>
    <StudentNotesHistorySection
      notes={notes}
      title={title}
      emptyMessage={emptyMessage}
      disableScroll
      footer={footer}
      onDeleteNote={onDeleteNote}
    />
  </div>
);

export default StudentNotesHistoryPanel;
